<template lang="html">
    <div class="editProject"  :class="{dark:darkmode}">
      <div class="contentWrapper">
        <AveInput :darkmode = "darkmode" v-model="projectTitle" icon="projects" :placeholder="currentTitle" :error="errorTitle" @focussed="errorTitle=''"/>
        <div class="container">
          <AveButton :darkmode = "darkmode" icon="wrong" icon-type="negative" label="Delete" @click="deleteProject" />
          <div class="gap"></div>
          <AveButton :darkmode = "darkmode" icon="done" icon-type="positive" label="Done" @click="editProject"/>
        </div>
    </div>
    </div>
</template>

<script>
import AveInput from '@/components/AveInput.vue';
import AveButton from '@/components/AveButton.vue';

export default {
  name: 'Components',
  components: {
    AveInput,
    AveButton,
  },
  data() {
    return {
      error: false,
      projectTitle: '',
      errorTitle: '',
    };
  },
  methods: {
    deleteProject() {
      this.$emit('deleteProject');
    },
    editProject() {
      let data = this.projectTitle;
      if (data === '') {
        data = this.currentTitle;
      }
      this.$emit('editProject', data);
      this.projectTitle = '';
      this.errorTitle = '';
    },
  },
  props: {
    darkmode: Boolean,
    currentTitle: {
      type: String,
      default: 'Task, To Do,...',
    },
  },
};
</script>

<style lang="stylus" scoped>
@require '../assets/styles/colors.styl'
@require '../assets/styles/styles.styl'

.container
  display flex
  flex-direction row

  .gap
    width: 25px

.contentWrapper
  margin: auto
</style>
